import axios from 'axios';

class ApiService {
  // Mock function to load the access token (replace this with your actual implementation)
  async loadAccessToken() {
    return localStorage.getItem('accessToken');
  }

  // Mock function to get the user ID (replace this with your actual implementation)
  async getDoctorId() {
    return localStorage.getItem('doctorId');
  }

  // API call to get payment entry status
  async getPaymentEntryStatus(assessmentId) {
    try {
      // Get access token and user ID
      const accessToken = await this.loadAccessToken();
      const userId = await this.getDoctorId();

      // Encode query parameters
      const encodedLoginId = encodeURIComponent(userId);
      const encodedAssessmentId = encodeURIComponent(assessmentId);

      const url = `${process.env.REACT_APP_BASE_URL}/payment_entry_status?login_id=${encodedLoginId}&assessment_id=${encodedAssessmentId}`;

      // Define headers
      const headers = {
        accessToken: accessToken,
      };

      // Make API request
      const response = await axios.get(url, { headers });

      // Return the response data based on the status code
      if (response.status === 200 || response.status === 404) {
        return response.data;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error fetching payment status:', error);
      return '';
    }
  }

  // API call to add a doctor
  async addDoctor(formData) {
    try {
      const accessToken = await this.loadAccessToken();

      const url = `${process.env.REACT_APP_BASE_URL}/addDoctor`;

      const headers = {
        accessToken: accessToken,
        'Content-Type': 'application/json',  
      };

      // Make the POST request to add a doctor
      const response = await axios.post(url, formData, { headers });

      if (response.status === 201) {
        return {
          status: 'Success',
          message: response.data.message,
        };
      } else {
        return {
          status: 'Unknown',
          message: 'An unknown error occurred',
        };
      }
    } catch (error) {
    if (error.response) {
      return {
        status: 'Error',
        message: error.response.data.message,
      };
    }
    }
  }

  // async getProfile(doctorID) {
  //   try {
  //     const accessToken = await this.loadAccessToken();
  //     const url = `${process.env.REACT_APP_BASE_URL}/getProfile?userId=${encodeURIComponent(doctorID)}`;
      
  //     const headers = {
  //       accessToken: accessToken,
  //       'Content-Type': 'application/json',
  //     };

  //     const response = await axios.get(url, { headers });

  //     console.log (response.data)
  //     if (response.status === 200) {
  //       console.log('API response:', response.data); // Log the full response
        
  //       return {
  //         status: 'Success',
  //         data: response.data.data,  // Extract the user profile data
  //       };
  //     } else {
  //       return {
  //         status: 'Unknown',
  //         message: 'An unknown error occurred',
  //       };
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       return {
  //         status: 'Error',
  //         message: error.response.data.message,
  //       };
  //     }
  //   }
  // }

  async getProfile(doctorID) {
    try {
      const accessToken = await this.loadAccessToken();
      const url = `${process.env.REACT_APP_BASE_URL}/getProfile?userId=${encodeURIComponent(doctorID)}`;
      
      // Create axios instance and set default headers
      const instance = axios.create({
        headers: {
          accessToken: accessToken,
          'Content-Type': 'application/json',
        }
      });
  
      // Add the ngrok header here
      instance.defaults.headers.common['ngrok-skip-browser-warning'] = '69420';
  
      const response = await instance.get(url);
  
      console.log(response.data);
      if (response.status === 200) {
        console.log('API response:', response.data); // Log the full response
        
        return {
          status: 'Success',
          data: response.data.data,  // Extract the user profile data
        };
      } else {
        return {
          status: 'Unknown',
          message: 'An unknown error occurred',
        };
      }
    } catch (error) {
      if (error.response) {
        return {
          status: 'Error',
          message: error.response.data.message,
        };
      }
    }
  }
  
  
  async updateDoctor(doctorData) {
    try {
      // Get access token
      const accessToken = await this.loadAccessToken();
  
      const url = `${process.env.REACT_APP_BASE_URL}/updateProfile`;
  
      const headers = {
        accessToken: accessToken,
        'Content-Type': 'multipart/form-data',  // Adjust content type if required
      };
  
      // Prepare form data
      const formData = new FormData();
      formData.append('firstname', doctorData.firstname || '');
      formData.append('lastname', doctorData.lastname || '');
      formData.append('email', doctorData.email || '');
      formData.append('userId', doctorData.email || '');
      formData.append('contact', doctorData.contact || '');
      formData.append('qualifications', doctorData.qualifications || '');
      formData.append('locations', doctorData.locations || '');
      formData.append('hospitals', doctorData.hospitals || '');
      formData.append('state', doctorData.state || '');
      formData.append('country', doctorData.country || '');
      formData.append('zipcode', doctorData.zipcode || '');
      formData.append('salutation', doctorData.salutation || 'Dr.');

  
      // Make the POST request to update the doctor
      const response = await axios.post(url, formData, { headers });
  
      if (response.status === 201) {
        return {
          status: 'Success',
          message: response.data.message,
        };
      } else {
        return {
          status: 'Unknown',
          message: 'An unknown error occurred',
        };
      }
    } catch (error) {
      if (error.response) {
        return {
          status: 'Error',
          message: error.response.data.message,
        };
      }
      console.error('Error updating doctor profile:', error);
    }
  }
  
  async deleteUser(docId) {
    try {
      const accessToken = await this.loadAccessToken();
  
      const url = `${process.env.REACT_APP_BASE_URL}/deleteUser`;
  
      const headers = {
        accessToken: accessToken,
        'Content-Type': 'application/x-www-form-urlencoded', 
      };
  
      // Prepare the form data
      const formData = new URLSearchParams();
      formData.append('docId', docId);
  
      // Make the POST request to delete the user
      const response = await axios.post(url, formData, { headers });
  
      if (response.status === 200) {
        return {
          status: 'Success',
          message: response.data.message,
        };
      } else {
        return {
          status: 'Error',
          message: response.data.message || 'An unknown error occurred',
        };
      }
    } catch (error) {
      if (error.response) {
        return {
          status: 'Error',
          message: error.response.data.message,
        };
      }
      console.error('Error deleting user:', error);
    }
  }
  
}

export default ApiService;
